<template>
  <section>    
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              #ID
            </th>
            <th class="text-left">
              Grupo
            </th>
            <th class="text-left">
              Valor
            </th>
            <th class="text-left">
              Descrição
            </th>            
            <th class="text-left">
              Status
            </th>
            <th class="text-left">
              Observação
            </th>
            <th class="text-left">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in payments"
            :key="item.id"
          >
            <td>{{ item.id }}</td>
            <td>{{  item.group ? item.group.raw : '-' }}</td>
            <td>{{ item.value.formatted }}</td>
            <td>{{ item.description }}</td>
            <td>              
              <v-chip
                class="ma-2"                
                :color="paymentStatusColor(item.status.raw)"
                text-color="white"                
              >              
                {{ item.status.label }}
              </v-chip>              
            </td>
            <td>{{ item.observation }}</td>
            <td>
              <v-btn 
                icon 
                v-if="item.url && item.url.raw"
                @click="openUrl(item)"
                title="Visualizar Boleto"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
            </td>           
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <OrderPaymentConfirmModal
      v-if="confirmModal.open"
      :payment="confirmModal.payment"
      @confirmed="onEventPaymentConfirm"
      @close="closeConfirmModal"
    />    
  </section>
</template>

<script>
  import { paymentStatusColor } from '@/util/payment-status-color'; 
  import PaymentService from '@/services/pagamento.service';

  export default {
    name: 'OrderDetailTabTrakings',
  
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      payments: [],

      confirmModal: {
        open: false,
        payment: null
      }
    }),

    mounted() {
      this.fetchPayments();
    },

    methods: {
      fetchPayments() {
        if (!this.order || !this.order.id) return;

        PaymentService
          .list(this.buildQueryParams())
          .subscribe({
            next: ({items}) => {            
              this.payments = items;            
            }
          });
      },

      paymentStatusColor(status) {
        return paymentStatusColor(status);
      },

      openUrl(payment) {
        if (!payment.url || !payment.url.raw) return;
        window.open(payment.url.raw, '_blank');
      },

      buildQueryParams() {
        const input = {
          ...(this.order.group && this.order.group.id ? { group_id: this.order.group.id } : { solicitation_id: this.order.id })
        };
        
        return {
          input,
          inputPage: {
            page: 1,
            per_page: 10,
            sort: 'id:desc'
          },
        };
      }
    }
  }
</script>